"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNetworkHealth = updateNetworkHealth;
var _extractMetricsFromChimeMetricReports = require("./extractMetricsFromChimeMetricReports");
var _networkHealthConfiguration = require("./networkHealthConfiguration");
var _NetworkHealthData = require("./NetworkHealthData");
var _networkHealthUtil = require("./networkHealthUtil");
var _NetworkHealthBufferedDispatcher = require("./NetworkHealthBufferedDispatcher");
/**
 * Contains the functionality for both network health indicator (aka signal strength) and
 * network health monitoring stats (used for internal dev/testing purposes only)
 * https://wiki.cvent.com/display/STUDIO/Network+Health+Indicator
 *
 * It uses WebRTC metrics received via Chime's metricsDidReceive callback. Metrics are
 * aggregated over a period of time before generating the network health stats to avoid
 * sending this data over the network too frequently. Instead of time, we use no. of samples
 * to aggregate metrics.
 * 1 sample = 1 batch of data received from metricsDidReceive
 * Typically, 1 sample of metrics is received every second (though it can vary)
 * So no. of samples is roughly equivalent to no. of seconds in timeframe
 */

var networkHealthData = new _NetworkHealthData.NetworkHealthData();
function updateNetworkHealth(clientMetricReport, meetingSession, currentAttendeeId, dispatch, setAttendeeNetworkHealth, setAttendeeReceivedFrame) {
  var metrics = (0, _extractMetricsFromChimeMetricReports.extractMetricsFromChimeMetricReports)(clientMetricReport, currentAttendeeId);
  networkHealthData.registerSample(metrics);
  if (shouldSendNetworkHealthData()) {
    var networkHealthPayload = networkHealthData.getNetworkHealthDataPayload(meetingSession);

    /**
     * Send my aggregated network health data over Chime's data channel
     * to be used by other directors/hosts
     */
    meetingSession.audioVideo.realtimeSendDataMessage(_networkHealthConfiguration.networkHealthConfiguration.chimeDataChannelName, networkHealthPayload, _networkHealthConfiguration.networkHealthConfiguration.chimeDataMessageLifetime);

    // Only for network health monitoring stats widgets
    if (dispatch) {
      // Update my local stats widget with my aggregated data
      updateLocalNetworkHealthStatsWidget(networkHealthPayload, currentAttendeeId, dispatch, setAttendeeNetworkHealth);

      /**
       * Update received video resolution and FPS of remote attendees in stats widgets
       * Received resolution/FPS can be different that what was sent by the remote attendee
       * because of SVC, so this is useful information to show
       */
      var videoMetricReport = clientMetricReport.getObservableVideoMetrics();
      updateReceivedVideoResolutionAndFPSForRemoteAttendees(videoMetricReport, currentAttendeeId, dispatch, setAttendeeReceivedFrame);
    }
    (0, _networkHealthUtil.sendNetworkHealthLogToDatadog)(networkHealthPayload, meetingSession, currentAttendeeId);
    networkHealthData.reset();
  }
}

/**
 * Have we collected enough valid samples to be able to aggregate and use
 */
function shouldSendNetworkHealthData() {
  return networkHealthData.getSampleCount() === _networkHealthConfiguration.networkHealthConfiguration.numMetricsSamplesToUseForAggregation;
}
function updateLocalNetworkHealthStatsWidget(networkHealthPayload, currentAttendeeId, dispatch, setAttendeeNetworkHealth) {
  if (!setAttendeeNetworkHealth) {
    return;
  }
  if (_NetworkHealthBufferedDispatcher.NetworkHealthBufferedDispatcher.instance) {
    _NetworkHealthBufferedDispatcher.NetworkHealthBufferedDispatcher.instance.updateNetworkHealthData(currentAttendeeId, networkHealthPayload.estimatedUplinkBandwidth, networkHealthPayload.estimatedDownlinkBandwidth, networkHealthPayload.audioPacketLoss, networkHealthPayload.audioJitter, networkHealthPayload.audioLatency, networkHealthPayload.audioMOS, networkHealthPayload.videoPacketLoss, networkHealthPayload.videoJitter, networkHealthPayload.videoLatency, networkHealthPayload.videoMOS, networkHealthPayload.videoFrame, networkHealthPayload.networkQuality);
  }
}

/**
 * videoMetricReport from metricsDidReceive contains downstream video metrics of
 * all remote attendees who have their cameras on
 * The resolution (frame width x frame height) and FPS data from this is used
 * to update the video received data in stats widgets for each attendee
 */
function updateReceivedVideoResolutionAndFPSForRemoteAttendees(videoMetricReport, currentAttendeeId, dispatch, setAttendeeReceivedFrame) {
  if (!setAttendeeReceivedFrame) {
    return;
  }
  for (var attendeeId in videoMetricReport) {
    var attendeeFrameReceived = 'NA';
    if (attendeeId !== currentAttendeeId) {
      for (var streamId in videoMetricReport[attendeeId]) {
        if (videoMetricReport[attendeeId][streamId].hasOwnProperty('videoDownstreamFrameHeight')) {
          var videoMetricsData = videoMetricReport[attendeeId][streamId];
          attendeeFrameReceived = "".concat(videoMetricsData.videoDownstreamFrameWidth, "x").concat(videoMetricsData.videoDownstreamFrameHeight, ", ").concat(videoMetricsData.videoDownstreamFramesDecodedPerSecond, "fps");
        }
      }
    }
    if (_NetworkHealthBufferedDispatcher.NetworkHealthBufferedDispatcher.instance) {
      _NetworkHealthBufferedDispatcher.NetworkHealthBufferedDispatcher.instance.updateReceivedFrameData(attendeeId, attendeeFrameReceived);
    }
  }
}